import React, { useState } from "react";
import Loader from "../Loader/loader";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const ForgotPassword = () => {
  const [emailSubmit, setEmailSubmit] = useState(false);
  const [otpValidate, setOtpValidate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [contentValue, setContentValue] = useState("Submit Your Email");

  const [inputField, setInputField] = useState({
    email: "",
    otp: "",
    newPassword: "",
  });

  const handleSubmit = () => {
    if (!emailSubmit) {
      sendOtp();
    } else if (emailSubmit && !otpValidate) {
   verifyOTP();
    }else{
      changePassword();
    }
  };

  const changePassword = async()=>{
  setLoader(true);
await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/auth/reset-password`, {email:inputField.email, newPassword:inputField.newPassword}).then((response)=>{

      toast.success(response.data.message);
      setLoader(false);
}).catch(err=>{
   toast.error("Some technical issue while sending mail")
   setLoader(false);
})
}

const verifyOTP = async()=>{
  setLoader(true);
await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/auth/reset-password/checkOtp`, {email:inputField.email, otp:inputField.otp}).then((response)=>{
      setOtpValidate(true);
      setContentValue("Submit Your New Password");
      toast.success(response.data.message);
      setLoader(false);
}).catch(err=>{
   toast.error("Some technical issue while sending mail")
   setLoader(false);
})
}

const sendOtp = async()=>{
  setLoader(true);
await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/auth/reset-password/sendOtp`, {email:inputField.email}).then((response)=>{
      setEmailSubmit(true);
      setContentValue("Submit Your OTP");
      toast.success(response.data.message)
      setLoader(false);
}).catch(err=>{
   toast.error("Some technical issue while sending mail")
   setLoader(false);
})
}

const handleOnChange = (event, name)=>{
    setInputField({...inputField, [name]:event.target.value});
}

  return (
    <div className="forgot-box">
      <div className="forgot-box-1">
        <div>Enter Your Email</div>
        <div className="">
          <input
            value={inputField.email}
            onChange={(event) => {
              handleOnChange(event, "email");
            }}
            className="loginInput"
            type="email"
            required
            placeholder="Enter Email"
          />
        </div>
      </div>

      {emailSubmit && (
        <div className="forgot-box-1">
          <div>Enter Your OTP</div>
          <div className="">
            <input
              value={inputField.otp}
              onChange={(event) => {
              handleOnChange(event, "otp");
            }}
              className="loginInput"
              type="text"
              required
              placeholder="Enter OTP"
            />
          </div>
        </div>
      )}

      {otpValidate && (
        <div className="forgot-box-1">
          <div>Enter Your New Password</div>
          <div className="">
            <input
              value={inputField.newPassword}
              onChange={(event) => {
              handleOnChange(event, "newPassword");
            }}
              className="loginInput"
              type="password"
              required
              placeholder="Enter New Password"
            />
          </div>
        </div>
      )}

      <div className="contact__button button" onClick={() => handleSubmit()}>
        {contentValue}
      </div>
    { loader && <Loader/>}
    <ToastContainer/>
    </div>
  );
};

export default ForgotPassword;
